import {
    LOAD_QUESTIONS_SUCCESS, RESET_QUESTIONS, REORDER_QUESTIONS_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_QUESTIONS_SUCCESS:
            return action.payload;
        case REORDER_QUESTIONS_SUCCESS:
            return action.payload;
        case RESET_QUESTIONS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/QuestionsReducer.js